export const removeBorder = {
  "& fieldset": {
    border: "none",
  },
};
